import React from 'react';
// Data
import { exclusionsArray, offeringsArray } from '../../utils/data/ServicesData';

function WhatIOfferComponent() {
  return (
    <section className='container mx-auto px-6 mt-8 lg:w-[60%]'>
      <h5 className='text-xl font-bold text-center text-colour2 font-castoro mb-2'>
        What I Offer
      </h5>

      <div className='grid gap-20'>
        {/* Do offer */}
        <article className='grid uppercase sm:px-10 xl:gap-x-10 md:px-16 lg:px-10'>
          <section className='grid grid-cols-[1fr_auto_1fr] w-full gap-x-6'>
            <div className='grid items-center'>
              <div
                className='h-[2px] -mt-4 bg-colour8'
                role='separator'
                aria-hidden='true'
              ></div>
            </div>
            {/* Large screen */}
            <div className='hidden md:grid items-center'>
              <h3 className='text-3xl font-titleFont tracking-widest text-colour8'>
                Kinks & Fetishes
              </h3>
            </div>
            {/* Phone screen */}
            <div className='grid md:hidden items-center'>
              <h3 className='text-3xl font-titleFont tracking-widest text-colour8'>
                Kinks & <br /> Fetishes
              </h3>
            </div>
            <div className='grid items-center'>
              <div
                className='h-[2px] -mt-4 bg-colour8'
                role='separator'
                aria-hidden='true'
              ></div>
            </div>
          </section>
          <ul className='mt-4 lg:mt-6 space-y-4 px-2 text-center'>
            {offeringsArray.map((item, index) => (
              <li key={index}>
                <div className='grid leading-4'>
                  <div>{item.label}</div>
                </div>
              </li>
            ))}
          </ul>
        </article>

        {/* Dont offer */}
        <article className='grid uppercase sm:px-10 text-center xl:gap-x-10 md:px-16 lg:px-10'>
          <section className='grid grid-cols-[1fr_auto_1fr] w-full gap-x-6'>
            <div className='grid items-center'>
              <div
                className='h-[2px] -mt-4 bg-[#da1c1c]'
                role='separator'
                aria-hidden='true'
              ></div>
            </div>
            {/* Large screen */}
            <div className='hidden md:grid items-center'>
              <h3 className='text-3xl font-titleFont tracking-widest'>
                I DO NOT OFFER
              </h3>
            </div>
            {/* Phone screen */}
            <div className='grid md:hidden items-center'>
              <h3 className='text-3xl font-titleFont tracking-widest'>
                I DO NOT <br /> OFFER
              </h3>
            </div>
            <div className='grid items-center'>
              <div
                className='h-[2px] -mt-4 bg-[#da1c1c]'
                role='separator'
                aria-hidden='true'
              ></div>
            </div>
          </section>
          <section>
            <p className='text-sm pt-4 opacity-75 text-center'>
              I do NOT offer the following, and will NOT consider it so do NOT
              ask for any of the following activities.
            </p>
          </section>
          <ul className='mt-4 lg:mt-6 space-y-4 px-2 text-center text-[#da1c1c]'>
            {exclusionsArray.map((item, index) => (
              <li key={index}>
                <div className='grid leading-4'>
                  <div>{item.label}</div>
                </div>
              </li>
            ))}
          </ul>
          <section>
            <p className='text-sm pt-6 opacity-75 text-center'>
              I believe in a mutually enjoyable encounter. I will respect your
              boundaries and ask that you respect MINE.
            </p>
          </section>
        </article>
      </div>
    </section>
  );
}

export default WhatIOfferComponent;
